import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('game-images-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('cms-gameImages', {
      parent: 'arw',
      url: '/cms-game-images/',
      template: `<cms-game-images></cms-game-images>`,
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Game Images')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/game-images-routing-module.js